module.exports = __webpack_public_path__ + "img/icon_tranfer.3fe9ac8d.png";